import { render, staticRenderFns } from "./accommodation.vue?vue&type=template&id=0ed87827"
import script from "./accommodation.vue?vue&type=script&lang=js"
export * from "./accommodation.vue?vue&type=script&lang=js"
import style0 from "./accommodation.vue?vue&type=style&index=0&id=0ed87827&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports